import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import type { BrowseTrack } from "@touchscreen/api-client";
import { useBrowseGroupTracks } from "@touchscreen/hooks";
import { TrackRow } from "../components/TrackRow.js";
import { LikeButton } from "../components/LikeButton.js";
import { RequestSheetHost } from "../components/RequestSheetHost.js";
import { artworkUrl } from "../lib/artwork.js";
import "./GroupScreen.css";

const PER_PAGE = 30;

export function GroupScreen(): React.JSX.Element {
  const { groupId } = useParams<{ groupId: string }>();
  const navigate = useNavigate();

  const { tracks, hasMore, loading, loadingMore, loadMore } = useBrowseGroupTracks(
    groupId ? Number(groupId) : null,
    PER_PAGE,
  );
  const [selectedTrack, setSelectedTrack] = useState<BrowseTrack | null>(null);

  return (
    <div className="group-screen">
      <button className="group-screen__back" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="group-screen__list">
        {tracks.map((track) => (
          <TrackRow
            key={track.sm_id}
            title={track.title}
            artist={track.artist}
            artworkUrl={track.artwork_ref ?? artworkUrl(track.sm_id)}
            onClick={() => setSelectedTrack(track)}
            trailing={<LikeButton smId={track.sm_id} title={track.title} artist={track.artist} />}
          />
        ))}
        {loading && tracks.length === 0
          ? Array.from({ length: 6 }, (_, i) => <div key={i} className="group-screen__skeleton" />)
          : null}
      </div>

      {hasMore ? (
        <button className="group-screen__load-more" disabled={loadingMore} onClick={loadMore}>
          {loadingMore ? "Loading…" : "Load more"}
        </button>
      ) : null}

      {selectedTrack ? <RequestSheetHost track={selectedTrack} onClose={() => setSelectedTrack(null)} /> : null}
    </div>
  );
}
